import React from 'react';
import Scroller from '../scroller/Scroller';
import SocialLinks from '../social_links/SocialLinks';
import Link from '../../../header/components/mobile_menu/link/Link';
import Copyright from '../copyright/Copyright';
import styles from './Footer.module.sass';

function Footer(props) {
  const { items } = props;

  return (
    <div className={styles['footer-wrapper']}>
      <div className={styles['footer-container']}>
        <SocialLinks />
        <div className={styles['links-container']}>
          {items.map((item) => (
            <Link
              key={item.id}
              className={styles.link}
              title={item.name}
              href={item.link}
              target={item.new_window ? '_blank' : undefined}
            />
          ))}
        </div>
        <Scroller />
      </div>
      <Copyright />
    </div>
  );
}

export default Footer;
